import { render, staticRenderFns } from "./SectionCta.vue?vue&type=template&id=0afc0f16&scoped=true"
import script from "./SectionCta.vue?vue&type=script&setup=true&lang=ts"
export * from "./SectionCta.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SectionCta.vue?vue&type=style&index=0&id=0afc0f16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afc0f16",
  null
  
)

export default component.exports